/**
 * Centralized email address configuration for the frontend.
 *
 * Every address defaults to @momentumeq.app and can be overridden
 * via VITE_EMAIL_* environment variables.
 */

const DOMAIN = "momentumeq.app";

/** Bare email addresses (e.g. "support@momentumeq.app") */
export const EMAIL = {
  noreply: import.meta.env.VITE_EMAIL_NOREPLY || `noreply@${DOMAIN}`,
  support: import.meta.env.VITE_EMAIL_SUPPORT || `support@${DOMAIN}`,
  sales: import.meta.env.VITE_EMAIL_SALES || `sales@${DOMAIN}`,
  privacy: import.meta.env.VITE_EMAIL_PRIVACY || `privacy@${DOMAIN}`,
  legal: import.meta.env.VITE_EMAIL_LEGAL || `legal@${DOMAIN}`,
} as const;
